import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';

import { StatusListRes } from '../patients/index.type';


interface IStatus {
  key: string;
  value: string;
}


const useFetchStatus = () => {
  const [status, setStatus] = React.useState<IStatus[]>();

  const { loading: fetchingStatus, makeApiCall } = useApi({
    url: `/rtm/general/status`,
    method: 'GET',
  });

  const fetchStatus = async () => {
    const { response, error } = await makeApiCall<undefined, StatusListRes>();

    if (response?.status) {

      const formattedData = (response.data || []).map((item: IStatus) => ({
        ...item,
        value: item.value.charAt(0).toUpperCase() + item.value.slice(1).toLowerCase(),
      }));
      setStatus(formattedData);
    } else {
      setStatus([]);
    }

    if (error) {
      toast.error(error.msg || 'Unable to load status options. Please refresh the page or try again later.');
    }
  };

  return {
    status,
    fetchStatus,
    fetchingStatus,
  };
};

export default useFetchStatus;
